import type { Mesh, Scene } from "@babylonjs/core";
import { createField } from "../terrain/height";
import type { WorldConfig } from "../world/config";
import type { Atmosphere } from "./scene";
import { buildLandmarks } from "./landmarks";
import { SceneryManager } from "./scenery";
import { TerrainManager } from "./terrainMesh";

export interface BuiltWorld {
  cfg: WorldConfig;
  height(x: number, z: number): number;
  terrain: TerrainManager;
  floors: Mesh[];
  atmosphere: Atmosphere;
}

export function buildWorld(scene: Scene, cfg: WorldConfig, atmosphere: Atmosphere): BuiltWorld {
  const field = createField(cfg.terrain);
  const height = (x: number, z: number) => field.height(x, z);
  const scenery = new SceneryManager(scene, cfg, height);
  const terrain = new TerrainManager(scene, height, cfg.terrain.colors, {
    created: (cx, cz) => scenery.onChunk(cx, cz),
    disposed: (cx, cz) => scenery.offChunk(cx, cz),
  });
  const { floors } = buildLandmarks(scene, cfg, height, atmosphere);
  return { cfg, height, terrain, floors, atmosphere };
}
